import { Ref } from "react";
import { Mask } from "antd-mobile";
import { debounce } from "@/utils";
import { useCallbackState } from "@/utils/hook";
import useTranslate from "@/hooks/useTranslate";
import bus from "@/utils/mitt";
import classNames from "classnames";
import { getLangMap } from "@/utils/getLangMap.ts";
import { clickTabAtom, keyDidAtom, refreshLocAtom, toggleCityAtom } from "@/atoms/app";
import { homeAtom } from "@/atoms/home";
import { refreshCurrGeo } from "@/atoms/utils/refreshCurrGeo";
import { keyAid, keyBid, keyCid, keyDid, keyId } from "@/atoms/common";
import { loadLocation } from "@/atoms/utils/loadLocation.ts";
import slideDistance from "@/utils/slideDistance";
import { useApiMap } from "@/atoms/hooks/useApiMap";
import { jotaiStore } from "@/atoms/store";
import timeZoneApi from "@/api/timeZoneApi";
import { waitForElement } from "@/utils/waitForElement";
function LocationMask(_props: any, ref: Ref<unknown> | undefined) {
  const fetchCurrRouteData = useSetAtom(homeAtom);
  const locInfo = LocalStorage.getItem("INFO");
  const setClickTab = useSetAtom(clickTabAtom);
  const [inputValue, setInputValue] = useCallbackState("");
  const [locationList, setLocationList] = useCallbackState([]);
  const [visible, setVisible] = useState(false);
  const [, setRefreshloc] = useAtom(refreshLocAtom);
  const [, setToggleCity] = useAtom(toggleCityAtom);
  useEffect(() => {
    bus.emit("toggleNewsVisibility", !visible);
  }, [visible]);
  const homeData = useAtomValue(homeAtom);
  let info = homeData?.data?.info;
  const { pathname } = useLocation();
  const searchInput = useRef<any>(null);
  if (isEmptyType(info)) {
    info = locInfo;
  }
  function handleClick() {
    if (!inputValue) return;
    searchInput.current.value = "";
    setLocationList([]);
    setInputValue("");
  }

  function handleInput({ target: { value } }: any) {
    setInputValue(value, async (cityName: any) => {
      if (!cityName.trim()) return setLocationList([]);
      const params = {
        test: isDevEnv ? 1 : undefined,
        type: "city",
        search: cityName,
      };
      const res: any = await loadLocation(params);
      setLocationList(res?.info?.list ?? []);
    });
  }
  async function fetchTimeZone(item: any) {
    refreshApi(item);
  }
  async function refreshApi(item: any) {
    const params = {
      keyId: item.Key,
      test: isDevEnv ? 1 : undefined,
      keyDid: item.keyDid,
    };
    timeZoneApi.query(params).then(resData => {
      const timeZone = resData.data.timeZone;
      LocalStorage.setItem("TIME_ZONE", timeZone);
      useApiMap({
        ...params,
        Accept: timeZone,
      });
    });
  }
  const handleRefreshCurrGeo = (e: any) => {
    e.stopPropagation();
    LocalStorage.removeItem("INFO");
    searchInput.current.value = "";
    setLocationList([]);
    setVisible(false);
    LocalStorage.removeItem("SELECT_CITY");
    LocalStorage.removeItem("TIME_ZONE");
    LocalStorage.removeItem("KEY_ID");
    setClickTab(false);
    setRefreshloc(true);
    setToggleCity(false);
    if (keyId || keyAid || keyBid || keyCid || keyDid) {
      refreshCurrGeo();
      return;
    }
    fetchCurrRouteData(pathname);
  };
  function handleSelectCity(item: any) {
    return () => {
      console.log("handleSelectCity", item);
      if (item?.keyDid) {
        jotaiStore.set(keyDidAtom, item.keyDid);
        LocalStorage.setItem("KEY_DID", item.keyDid);
      } else {
        LocalStorage.removeItem("KEY_DID");
        jotaiStore.set(keyDidAtom, "");
      }
      LocalStorage.removeItem("INFO");
      setClickTab(false);
      searchInput.current.value = "";
      setLocationList([]);
      setVisible(false);
      LocalStorage.setItem("SELECT_CITY", item);
      // setRefreshloc(true);
      setToggleCity(true);
      fetchTimeZone(item);
    };
  }

  useImperativeHandle(ref, () => ({
    setVisible,
    visible,
  }));
  const animateNode = useRef<any>(null);
  waitForElement(animateNode).then((el: any) => {
    if (!el) {
      return;
    }
    requestAnimationFrame(() => {
      slideDistance({
        end: el?.parentElement?.clientWidth - el?.clientWidth,
      })(animateNode.current);
    });
  });

  const maskStyle = {
    top: "50px",
    height: `calc(100dvh - 50px)`,
    backdropFilter: "blur(3px)",
  };
  const iconFontStyle = {
    color: "var(--app-text-05)",
    fontSize: "16px",
    lineHeight: "30px",
  };
  const { $t } = useTranslate();
  const lan = getLangMap();
  return (
    <>
      <Mask
        style={maskStyle}
        color="var(--app-text-30)"
        visible={visible}
        onMaskClick={() => {
          setVisible(false);
        }}
      >
        <div className="w-full p-15 rounded-tl-0 rounded-[0_0_10_10] bg-[var(--app-bg-01)] absolute top-0 left-0 z-1 color-[var(--app-text-11)]">
          <div className="relative w-full h-30 lh-30 inline-block">
            <IconFont
              iconName={inputValue ? "icon-guanbi" : "icon-sousuoxiao"}
              onClick={handleClick}
              style={iconFontStyle}
              className="w-30 h-30 absolute top-0 right-0 z-1 text-center color-[var(--app-text-05)]"
            />
            <input
              ref={searchInput}
              className="w-full h-30 bg-[var(--app-bg-04)] rounded-30 border-none p-[0_10] relative text-16 px-15"
              type="search"
              placeholder={$t("title20")}
              onFocus={({ target }) => {
                console.log(target);
                target.placeholder = "";
              }}
              onBlur={({ target }) => {
                target.placeholder = $t("title20");
              }}
              onInput={debounce(handleInput, 800)}
            />
          </div>
          <div
            className={classNames([
              "overflow-hidden whitespace-nowrap text-ellipsis flex items-center gap-x-5 p-[15px_0_5px_0]",
            ])}
          >
            {renderIconFont("icon-weizhi1", {
              color: "var(--app-text-11)",
              fontSize: "16px",
            })}
            <span onClick={handleRefreshCurrGeo}>{$t("title19")}</span>
          </div>
          <ul className="w-full max-h-280 overflow-y-scroll p-[5_10]">
            {locationList.map((item: any, index: number) => (
              <li
                className="h-30 lh-30 w-full overflow-hidden  whitespace-nowrap text-ellipsis"
                key={index}
                onClick={handleSelectCity(item)}
              >
                {item.LocalizedName}, {item.AdministrativeArea.LocalizedName}, {item.Country.LocalizedName}
              </li>
            ))}
          </ul>
        </div>
      </Mask>

      <div
        className={classNames([
          "inline-block whitespace-nowrap px-4 py-0 flex justify-start items-center font-[Roboto_Light]",
        ])}
        ref={animateNode}
      >
        {info?.name}
        {info?.name && info?.area?.LocalizedName
          ? ["pt", "vi"].includes(lan?.toLocaleLowerCase?.())
            ? ", "
            : ","
          : ""}
        {info?.area?.LocalizedName}
        {/* 测试数据 */}
        {/* Downtown,California */}
      </div>
    </>
  );
}

export default forwardRef(LocationMask);
